module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/info_image@1x.6f930c0.png";